import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@ortho-next/auth-core';
import { PAGE } from '../../app.routes';
import { APP_CONFIGURATION_TOKEN } from '../../core';
import { CookieBannerService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Vertical bar on the left fo template.
 */
@Component({
	selector: 'tsp-sidebar',
	imports: [
		RouterLink,
		RouterLinkActive,
		NgbDropdownModule
	],
	templateUrl: './sidebar.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SidebarComponent extends BaseComponent {

	private readonly authSrv = inject(AuthService);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);
	private readonly cookieBannerSrv = inject(CookieBannerService);

	buildVersion: string = this.configs.buildVer;
	envName: string = this.configs.envName;

	readonly PAGE = PAGE;


	/**
	 * Open about page in new tab.
	 */
	openAboutPage(): void {
		window.open(`${this.configs.aboutSite}${this.langSrv.currentLang}`, '_blank');
	}

	/**
	 * Open cookie preferences modal.
	 */
	openCookieModal(): void {
		this.cookieBannerSrv.openPreferencesModal();
	}

	logout(): void {
		this.authSrv.singleSignOut();
	}
}
